import styled from 'styled-components'

import { Image as ImageBase } from '@application/Interfaces/Atoms/Image'

export const Wrapper = styled.div`
    background-color: ${(props) => props.theme.color.p600};
`

export const Row = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 5px 30px;
    max-width: 1170px;
    margin: 0 auto;

    @media ${(props) => props.theme.query.min.tablet} {
        flex-direction: row;
        justify-content: space-between;
        padding: 0 45px;
    }
`

export const Item = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-top: 10px;
    padding-bottom: 10px;

    img {
        max-width: 20px;
    }

    @media ${(props) => props.theme.query.min.tablet} {
        padding-top: 20px;
        padding-bottom: 20px;
        margin-right: 60px;

        &:last-child {
            margin-right: 0;
        }
    }
`

export const Title = styled.div`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.regular};
    color: ${(props) => props.theme.color.white};
    margin-left: 5px;
`

export const Image = styled(ImageBase)`
    max-width: 20px;
`
